import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import MAdapter from "./MAdapter";
import { getCookie, setCookie } from "../utils/cookies";
import { getShareMessage, urlFormatter, addMetricToObj, isHTTPUrl, isZZ, isZZUrl, isZZSellerUrl, isZLJUrl, isCheckUrl, domainReplacement, getPPU, addQuery, formartChooseAddressRes } from "../utils/utils";
import compareVersion from "../utils/compareVersion";
import { setCookieOrigin } from "../utils/cookies";
import { beforeLogin } from "./Login";
import { platform } from "../platform/getCurrentPlatform";
var ZZAdapter = (_class = /*#__PURE__*/function (_MAdapter) {
  _inherits(ZZAdapter, _MAdapter);

  var _super = _createSuper(ZZAdapter);

  function ZZAdapter() {
    var _this;

    _classCallCheck(this, ZZAdapter);

    return _this = _super.call(this, "https://s1.zhuanstatic.com/common/zzapp/static/js//1.28.6/index.min.js", function () {
      _this.ZZAPP = window.ZZAPP = window["@zz-common/zz-jssdk"]["default"];
      _this.__sdk = _this.ZZAPP;
    });
  }

  _createClass(ZZAdapter, [{
    key: "setTitle",
    value: function setTitle(obj) {
      this.ZZAPP.setTitle(obj);
    }
  }, {
    key: "share",
    value: function share(shareMessage, callback) {
      this.ZZAPP.setRightShareBtn(Object.assign({}, getShareMessage(shareMessage), {
        needSuccessToast: '1'
      }), callback);
    }
  }, {
    key: "shareDetail",
    value: function shareDetail(obj, callback) {
      var defaultPicPath = "https://pic2.zhuanstatic.com/bidding/big/n_v1bkujjd2nmb7fmlmfhq4a_5ea9d0b68923e35c.png?w=640&h=480";
      var url = obj.url,
          picPaths = obj.picPaths;
      url = urlFormatter(url);
      picPaths = picPaths || defaultPicPath;
      this.ZZAPP.setShareData(Object.assign({}, obj, {
        url: url,
        picPaths: picPaths
      }), callback);
    }
  }, {
    key: "shareClick",
    value: function shareClick(shareMessage, callback) {
      if (!isZZ) {
        this.ZZAPP.openShare(_objectSpread(_objectSpread({}, getShareMessage(shareMessage)), {}, {
          type: 6,
          success: function success(data) {
            callback && callback(_objectSpread({
              code: "0"
            }, data));
          },
          fail: function fail() {
            callback && callback(_objectSpread({
              code: "-200"
            }, data));
          }
        }));
      } else {
        this.ZZAPP.setSharePanel(getShareMessage(shareMessage), callback);
      }
    }
  }, {
    key: "shareToAssignPlatform",
    value: function shareToAssignPlatform(shareMessage, callback) {
      this.ZZAPP.shareToPlatform(getShareMessage(shareMessage), callback);
    }
  }, {
    key: "setRightBtn",
    value: function setRightBtn(obj, callback) {
      var self = this;
      obj.url = domainReplacement(obj.url);

      if (!isZZ) {
        this.ZZAPP.changeRightButton({
          title: obj.label,
          icon: obj.icon,
          action: function action() {
            self.skipToUrl({
              targetUrl: obj.url
            });
          }
        });
      } else {
        this.ZZAPP.setRightBtn(obj, callback);
      }
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail(obj, callback) {
      var _this2 = this;

      if (!isZZ) {
        _get(_getPrototypeOf(ZZAdapter.prototype), "skipToDetail", this).call(this, obj);
      } else {
        var zzInfoId = obj.zzInfoId,
            infoId = obj.infoId,
            metric = obj.metric,
            from = obj.from;
        zzInfoId && (infoId = zzInfoId);

        if (from && from == '13') {
          this.enterUnifiedUrl({
            unifiedUrl: "zhuanzhuan://jump/core/infoDetail/jump?" + "infoId=".concat(infoId) + "&FROM=".concat(from) + "&metric=".concat(metric)
          });
        } else {
          this.agentSkipToDetail(obj, function () {
            _this2.ZZAPP.enterDetail(Object.assign({}, obj, {
              zzInfoId: zzInfoId,
              infoId: infoId,
              metric: metric
            }), callback);
          });
        }
      }
    }
  }, {
    key: "skipToUrl",
    value: function skipToUrl(obj, callback) {
      var targetUrl = obj.targetUrl,
          _obj$needNewWindow = obj.needNewWindow,
          needNewWindow = _obj$needNewWindow === void 0 ? true : _obj$needNewWindow;
      targetUrl = urlFormatter(targetUrl);
      targetUrl = domainReplacement(targetUrl);

      if (isZZUrl(targetUrl) || isZZSellerUrl(targetUrl) || isCheckUrl(targetUrl)) {
        return this.enterUnifiedUrl(Object.assign({}, obj, {
          unifiedUrl: targetUrl
        }), callback);
      }

      if (needNewWindow) {
        if (!isZZ) {
          this.skipToUrlZLJ(obj);
        } else {
          this.ZZAPP.enterPage(Object.assign({}, obj, {
            targetUrl: targetUrl
          }), callback);
        }
      } else {
        _get(_getPrototypeOf(ZZAdapter.prototype), "skipToUrl", this).call(this, obj);
      }
    }
  }, {
    key: "skipToUrlZLJ",
    value: function skipToUrlZLJ(obj) {
      var targetUrl = obj.targetUrl,
          _obj$needClose = obj.needClose,
          needClose = _obj$needClose === void 0 ? 0 : _obj$needClose;
      targetUrl = urlFormatter(targetUrl);

      if (isZLJUrl(targetUrl)) {
        location.href = targetUrl;
      } else {
        var closebefore = 0;

        if (needClose == 1) {
          closebefore = 1;
          targetUrl = addQuery(targetUrl, {
            closebefore: 1
          });
        }

        location.href = "zljgo://native_api?type=1&closebefore=".concat(closebefore, "&content=").concat(encodeURIComponent(targetUrl));
      }
    }
  }, {
    key: "skipToOrder",
    value: function skipToOrder(obj, callback) {
      var newObj = addMetricToObj(obj);
      this.ZZAPP.enterConfirmOrder(newObj, callback);
    }
  }, {
    key: "login",
    value: function login(callback) {
      var _this3 = this;

      var zljOpt = {
        type: 0
      };
      var forceLogin = false;

      if (_typeof(callback) === "object") {
        zljOpt = callback.zljOpt || zljOpt;
        forceLogin = callback.forceLogin || forceLogin;
        callback = callback.callback;
      }

      var successCb = function successCb() {
        var loginInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var token = loginInfo.token;

        if (token.indexOf("UID=") > -1) {
          setCookieOrigin("uid", getPPU(token).UID);
          setCookieOrigin("PPU", "\"".concat(token, "\""));
        }

        callback && callback(loginInfo);
      }; // 找靓机的新webveiw


      if (!isZZ) {
        if (forceLogin) {
          this.ZZAPP.zljlogin(zljOpt, successCb);
          return;
        }

        this.ZZAPP.getUserInfo({}, function (res) {
          if (!res.token) {
            _this3.ZZAPP.zljlogin(zljOpt, successCb);
          } else {
            callback && callback(res);
          }
        });
        return;
      }

      var cookieCallback = function cookieCallback(json) {
        if (+json.code === 0) {
          _this3.ZZAPP.getCookie(function (res) {
            var v = getCookie("v");
            var ua = navigator.userAgent;

            if (location.host === "m.zhuanzhuan.com" && (!v || v < "4.7") && /58ZhuanZhuan/.test(ua)) {
              // 把cookie设置在下.zhuanzhuan.com
              if (res && res.cookie) {
                var arr = res.cookie.split(";");
                arr.map(function (d) {
                  return d.trim();
                }).filter(function (d) {
                  return d;
                }).map(function (d) {
                  var m = d.match(/^([^=]+)=(.*)/);

                  if (m && m.length) {
                    return {
                      key: m[1],
                      value: m[2]
                    };
                  }
                }).forEach(function (d) {
                  setCookie(d.key, d.value, {
                    expires: 365,
                    domain: location.host.replace(/.*(\.[^\.]*\.[^\.]*)$/, "$1")
                  });
                });
              }
            }
          });
        }

        callback(json);
      };

      this.ZZAPP.login(cookieCallback || function () {});
    }
  }, {
    key: "skipToSearchResult",
    value: function skipToSearchResult(obj, callback) {
      // obj.cityId = obj.cityId || "0";
      // obj.sortType = obj.sortType || "0";
      // obj.startPrice = obj.startPrice || -1;
      // obj.endPrice = obj.endPrice || -1;
      // obj.listType = obj.listType || "0";
      // this.ZZAPP.enterSearchResult(obj, callback);
      this.enterUnifiedUrl({
        unifiedUrl: "zhuanzhuan://jump/core/searchResult/jump?" + "cityId=".concat(obj.cityId || "0") + "cateId=".concat(obj.cateId || "0") + "&sortType=".concat(obj.sortType || "0") + "&startPrice=".concat(obj.startPrice || "") + "&endPrice=".concat(obj.endPrice || "") + "&keyword=".concat(encodeURIComponent(obj.keyWord || obj.title || "")) + "&searchType=0"
      });
    }
  }, {
    key: "enlargeImage",
    value: function enlargeImage(obj, callback) {
      if (!isZZ) {
        this.ZZAPP.browsePicture({
          index: obj.selectedIndex,
          list: obj.imgUrls.split("|")
        });
      }

      this.ZZAPP.enlargeImage(obj, callback);
    }
  }, {
    key: "getContextInfo",
    value: function getContextInfo(callback) {
      if (typeof callback !== 'function') {
        callback = callback.success;
      }

      if (platform.name === "zlj") {
        callback(this.ZZAPP.zljGetContextInfo({}));
      } else {
        this.ZZAPP.getContextInfo({}, callback);
      }
    }
  }, {
    key: "uploadPhotos",
    value: function uploadPhotos(obj, callback) {
      obj.maxAllowCount = obj.maxAllowCount || "5";
      this.ZZAPP.uploadPhotos(obj, callback);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(callback) {
      if (typeof callback !== 'function') {
        callback = callback.success;
      }

      if (platform.name === "zlj") {
        callback(this.ZZAPP.zljGetUserInfo({}));
      } else {
        this.ZZAPP.getUserInfo({}, callback);
      }
    }
  }, {
    key: "toast",
    value: function toast(obj, callback) {
      this.ZZAPP.toast(obj, callback);
    }
  }, {
    key: "close",
    value: function close(callback) {
      if (_typeof(callback) === "object") {
        callback = callback.callback;
      }

      this.ZZAPP.close(callback);
    }
  }, {
    key: "enterProfile",
    value: function enterProfile(obj, callback) {
      this.ZZAPP.enterProfile(obj, callback);
    }
  }, {
    key: "enterChat",
    value: function enterChat(obj) {
      if (obj.useWeb) {
        _get(_getPrototypeOf(ZZAdapter.prototype), "enterChat", this).call(this, obj);

        return;
      }

      this.ZZAPP.enterChat(obj);
    }
  }, {
    key: "nativeShare",
    value: function nativeShare(obj, callback) {
      this.ZZAPP.nativeShare(obj, callback);
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var addressId = obj.addressId;

      if (!isZZ) {
        this.ZZAPP.chooseReceiveAddress({
          addressId: addressId || 0,
          success: function success(res) {
            try {
              callback && callback(formartChooseAddressRes(res));
            } catch (error) {
              console.log(error);
            }
          },
          fail: function fail(res) {
            callback && callback(res);
          }
        });
      } else {
        this.ZZAPP.chooseAddress({
          addressId: addressId || 0
        }, callback);
      }
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(obj) {
      this.ZZAPP.enterUnifiedUrl({
        unifiedUrl: "" + "zhuanzhuan://jump/core/routePlan/jump?" + "goodLatitude=".concat(obj.lat) + "&goodLongitude=".concat(obj.lon) + "&goodVillage=".concat(encodeURIComponent(obj.name || "")) + "&goodAddress=".concat(encodeURIComponent(obj.address || ""))
      });
    }
  }, {
    key: "setPageBackAction",
    value: function setPageBackAction(callback) {
      if (!isZZ) {
        if (compareVersion(getCookie("v"), "9.1.10") >= 0) {
          this.ZZAPP.setPageBackAction(function () {
            if (arguments.length <= 0 ? undefined : arguments[0]) {
              return callback.apply(void 0, arguments);
            }
          });
        } else {
          this.ZZAPP["on"]("backEvent", function () {
            callback && callback();
          });
        }
      } else {
        this.ZZAPP.setPageBackAction(function () {
          if (arguments.length <= 0 ? undefined : arguments[0]) {
            return callback.apply(void 0, arguments);
          }
        });
      }
    }
  }, {
    key: "cancelPageBackAction",
    value: function cancelPageBackAction(callback) {
      this.ZZAPP.cancelPageBackAction(callback);
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan(obj, callback) {
      if (platform.name === "zlj") {
        this.ZZAPP.qrCodeScan(function (res) {
          if (callback) {
            callback({
              code: res && res.qrCode ? "0" : -1,
              resultString: res.qrCode || "",
              resultStr: res.qrCode || "",
              msg: ""
            });
          }
        });
      } else {
        this.ZZAPP.getQRCodeScan(obj, function (res) {
          if (callback) {
            callback({
              code: res.code,
              resultString: res.resultString || "",
              resultStr: res.resultString || "",
              msg: ""
            });
          }
        });
      }
    }
  }, {
    key: "qrCodeScan",
    value: function qrCodeScan() {
      var _this$ZZAPP;

      (_this$ZZAPP = this.ZZAPP).qrCodeScan.apply(_this$ZZAPP, arguments);
    }
  }, {
    key: "getSystemExtraInfo",
    value: function getSystemExtraInfo(param) {
      var success = param.success || function () {};

      success(this.ZZAPP.getSystemExtraInfo());
    }
  }, {
    key: "enterOrderDetail",
    value: function enterOrderDetail() {
      var _this$ZZAPP2;

      (_this$ZZAPP2 = this.ZZAPP).enterOrderDetail.apply(_this$ZZAPP2, arguments);
    }
  }, {
    key: "deliverSelectedParamInfoToPublish",
    value: function deliverSelectedParamInfoToPublish() {
      var _this$ZZAPP3;

      (_this$ZZAPP3 = this.ZZAPP).deliverSelectedParamInfoToPublish.apply(_this$ZZAPP3, arguments);
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl() {
      var _this$ZZAPP4;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var url = args[0].unifiedUrl;

      var cb = args[1] || function () {};

      var encodePath = encodeURIComponent(url);

      if (isHTTPUrl(url) && isZZ) {
        this.skipToUrl({
          targetUrl: url
        }, cb);
        return;
      }

      if (isZZSellerUrl(url)) {
        this.ZZAPP.enterUnifiedUrl({
          unifiedUrl: "zhuanzhuan://jump/core/openZhuanZhuanSeller/jump?url=".concat(encodePath)
        }, cb);
        return;
      }

      if (isHTTPUrl(url) && !isZZ) {
        this.ZZAPP.enterUnifiedUrl({
          unifiedUrl: "zljgo://native_api?type=1&content=".concat(encodePath)
        }, cb);
        return;
      }

      (_this$ZZAPP4 = this.ZZAPP).enterUnifiedUrl.apply(_this$ZZAPP4, args);
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      var useOrigin;

      if (_typeof(callback) === "object") {
        useOrigin = callback.useOrigin;
        callback = callback.callback;
      }

      if (useOrigin === true) {
        this.ZZAPP.registerPageCallback(function (res) {
          callback && callback(res);
        });
      } else {
        this.ZZAPP.registerPageCallback(function (res) {
          if (res && res.code === "0" && res.pageState === "1") {
            callback && callback(res);
          }
        });
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(callback) {
      this.ZZAPP.getCoordinate(callback);
    }
  }, {
    key: "getCookie",
    value: function getCookie(callback) {
      this.ZZAPP.getCookie(callback);
    }
  }]);

  return ZZAdapter;
}(MAdapter), (_applyDecoratedDescriptor(_class.prototype, "login", [beforeLogin], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
export { ZZAdapter as default };